import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Router } from '@remix-run/router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@ds';
import { LogisticsPlatformAppProvider } from '@lp/core/app';
import { useUserSettingsStore } from '@/store/user-settings.store';
import { IS_DEV_MODE, USE_DEVTOOLS } from '@/constants/env.constants';
import { queryClient } from '@/queries';
import { TitleProvider } from '@/routing/document-title';
import 'react-toastify/dist/ReactToastify.css';

type AppProps = { router: Router };

export const App = ({ router }: AppProps) => {
  const theme = useUserSettingsStore((state) => state.theme);

  return (
    <LogisticsPlatformAppProvider>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <TitleProvider>
            <RouterProvider router={router} />
          </TitleProvider>
          {IS_DEV_MODE && USE_DEVTOOLS && <ReactQueryDevtools buttonPosition="top-left" initialIsOpen={false} />}
          <ToastContainer
            autoClose={2000}
            position="bottom-center"
            closeOnClick={false}
            closeButton={false}
            hideProgressBar
            toastStyle={{ whiteSpace: 'pre-line' }}
          />
        </QueryClientProvider>
      </ThemeProvider>
    </LogisticsPlatformAppProvider>
  );
};
